<section class="container-fluid">

  <div class="vegetables-seasons">

    <div>
      <span>
        Our Growing Seasons:
      </span>
      <span>
        What can I expect?
      </span>
    </div>

    <div>
      <span>
        Spring Season: May-June
      </span>
      <span>
        Spring greens, asparagus, rhubarb, peas, scallions, arugula, garlic scapes, strawberries, raspberries
      </span>
    </div>

    <div>
      <span>
        Peak Season: July-Nov
      </span>
      <span>
        Romaine lettuce, summer squash, tomatoes, peppers, eggplant, berries, melons, stone fruit and more
      </span>
    </div>

    <div>
      <span>
        Winter Season: Dec-April
      </span>
      <span>
        Sweet potatoes, carrots, beets, winter squash, winter greens, apples, pears, citrus
      </span>
    </div>

    <div>
      <span>
        Year Round
      </span>
      <span>
        Mushrooms, onions, potatoes, eggs, dairy, meat, sourdough bread, seafood, pantry staples
      </span>
    </div>

  </div>

  <span class="h3-semibold">
    Subscribe to one of our curated farm boxes
  </span>

  <!-- CATEGORIES -->

  <mat-tab-group class="animated fadeIn mt-3">

    @for (category of categories(); track $index) {
    <mat-tab [label]="category.name">
      <div class="row mt-4 mx-0">
        @for (product of category.products; track product.id) {
        @defer (on viewport; prefetch on immediate) {
        <div class="col-xl-4 col-lg-4 col-12 animated fadeIn mb-3">
          <div class="product-card-grid__item">
            <app-product-card class="product-card__box selected" [card]="{product}" [customizeBox]="true"
              [isSignupFlow]="true" (click)="selectCard(product)">
            </app-product-card>
          </div>
        </div>
        } @placeholder {
        <div class="col-xl-4 col-lg-4 col animated fadeInUp fadeIn mb-3">
          <div class="card position-relative border p-3 row-gap-3" aria-hidden="true">
            <span class="placeholder bg-secondary col-12"></span>
            <span class="placeholder bg-secondary col-6"></span>
            <div class="placeholder bg-secondary col-12" style="height: 100px"></div>
            <div class="card-body">
              <h5 class="card-title placeholder-glow">
                <span class="placeholder bg-secondary col-6"></span>
              </h5>
              <p class="card-text placeholder-glow">
                <span class="placeholder bg-secondary col-7"></span>
                <span class="placeholder bg-secondary col-4"></span>
                <span class="placeholder bg-secondary col-4"></span>
                <span class="placeholder bg-secondary col-6"></span>
                <span class="placeholder bg-secondary col-8"></span>
              </p>
            </div>
          </div>
        </div>
        }
        }
      </div>
    </mat-tab>
    }

  </mat-tab-group>

  <div class="form-row-action">
    <div class="d-grid gap-2 mt-4 col-md-4 col-12 mx-auto">
      <button type="button" class="btn btn-secondary" (click)="continue()">
        Finish Registration
      </button>
    </div>
  </div>
</section>